export default __webpack_public_path__ + "static/media/icon-baby-transparent.a977ef82.png";